import {
  GET_ALL_BACKUP_VAULTS_WITH_ITEMS,
  GET_VM_BACKUP_HISTORY,
} from "../../infrastructure/graphql/backupQueries";
import { client } from "../../infrastructure/graphql/client";

export class BackupService {
  async getVmBackupHistory(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_VM_BACKUP_HISTORY,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getVmBackupHistoryByDateRange;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM backup history error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
  async getAllBackupVaultsWithItems() {
    try {
      const result = await client.query({
        query: GET_ALL_BACKUP_VAULTS_WITH_ITEMS,
        fetchPolicy: "network-only",
      });

      const response = result.data?.getAllBackupVaultsWithItems;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get all backup vaults with items error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}
